import { SET_BOOKING_SLOT_ID } from 'redux/modules/slots/actions/types';

export const slotBeingBooked: (slotId: string | null) => WtrAction = slotId => ({
  type: SET_BOOKING_SLOT_ID,
  payload: {
    slotId,
  },
});
